export const utmSessionName = 'utmDetailsInput';